import React from 'react';
import { useAuth } from '../../context/AuthContext';
import AdminDashboard from './Dashboard';
import StockHome from './StockHome';

/**
 * WINE-DB-NAV.1 — what /admin actually opens on, per role.
 *
 * The landing page was five cards reading Wines, Producers, Regions, Grape
 * Varieties and Wine Names — with no role check anywhere in that file — while
 * the sidebar had deliberately hidden every one of them from ADMIN. The wine
 * master data is shared across every client, so editing it is not a per-tenant
 * act, and an admin's first screen was entirely the thing they were not
 * supposed to be doing. The cards were clickable, so it was not even a
 * cosmetic mismatch: it was the door the nav rule never reached.
 *
 * A SYSTEM_ADMIN still lands on the wine dashboard, because for them it IS the
 * job. Everyone else lands on their stock.
 *
 * Split at the ROUTE rather than branching inside Dashboard: the two screens
 * share nothing, and a component that renders one of two unrelated pages is a
 * place where each accumulates the other's props.
 */
const AdminHome: React.FC = () => {
  const { isSystemAdmin } = useAuth();
  return isSystemAdmin() ? <AdminDashboard /> : <StockHome />;
};

export default AdminHome;
